import apiConfig from "src/utils/apiConfig";

export const FETCH_GETCORPORATE_TRIP = "CorTrip/fetchCorporateTripRequest";

export const fetchCorporateTrip = (
  fromdate: any,
  todate: any,
  filter?: any,
  limit?: number,
  skip?: number
) => {
  let endpoint = `${apiConfig.GETCORPORATETRIP}/?fromdate=${fromdate}&todate=${todate}`;

  if (filter && filter.trim() !== "") {
    endpoint += `&filter=${encodeURIComponent(filter.trim())}`;
  }
  if (limit !== undefined) {
    endpoint += `&limit=${limit}`;
  }
  if (skip !== undefined) {
    endpoint += `&skip=${skip}`;
  }
  const apiobject = {
    method: "GET",
    authentication: true,
    endpoint,
  };

  return {
    type: FETCH_GETCORPORATE_TRIP,
    payload: apiobject,
  };
};
